import script from "./ScreenshotViewerBridge.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenshotViewerBridge.vue?vue&type=script&setup=true&lang=js"

import "./ScreenshotViewerBridge.vue?vue&type=style&index=0&id=12b98d65&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b98d65"]])

export default __exports__